












import { Vue, Component, Prop } from "vue-property-decorator";
import BaseTitle from "./base-title.vue";
@Component({
  components: {
    BaseTitle
  }
})
export default class OrderUserRating extends Vue {
  @Prop(Number) rating!: number;
}
